export const scrollBarStyle = {
  '&::-webkit-scrollbar': {
    zIndex: 1,
    width: '10px',
    bgColor: 'transparent',
  },
  '&::-webkit-scrollbar-track': {
    zIndex: 1,
    bgColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    zIndex: 1,
    bgColor: 'bg.gray',
    boxSizing: 'content-box',
    border: '4px solid',
    borderColor: 'bg.white',
    h: '15px',
    borderRadius: '24px',
  },
  '::-webkit-scrollbar-track-piece:end': {
    background: 'transparent',
    mb: '15px',
  },
  '::-webkit-scrollbar-track-piece:start': {
    background: 'transparent',
    mt: '15px',
  },
};
